import { api } from 'API/axios';
import { addImposterToUrl } from 'Utils';

const baseURL = '/MenuItems';

export interface IBurgerMenuItem {
  isVisible: boolean;
  description: string;
  id: number;
  iconUrl: string;
  mobileIconUrl: string;
  internalLink?: string;
  externalLink?: string;
  isNewItem: boolean;
  subItems?: IBurgerMenuItem[];
}

export const getBurgerMenuItems = async (isLawyer?: boolean) => {
  const burgerMenuItems = await api.get<IBurgerMenuItem[]>(
    addImposterToUrl(`${baseURL}${isLawyer ? '/representatives' : ''}`, true),
  );
  if (burgerMenuItems.data) return burgerMenuItems.data;
};
